module.exports = __webpack_public_path__ + "static/media/nesto-bulk-upload-template.c10873dd.xlsx";